/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Dépendance==================
import {
  Routes, Route, Navigate,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';

// ==================Composant===================
import Header from '../Header';
import Footer from '../Footer';
import Site from '../Site';
import Metadata from '../Metadata';
import File from '../File';
import ModalCommandLineClient from '../Site/ModalCommandLineClient';
import Network from '../Network';
import MultipleMetadata from '../MultipleMetadata';
import NodeInfo from '../NodeInfo';
import Personalized from '../Personalized';
import PopupCookie from '../PopupCookies';

// ==================Action======================
import { fetchStations } from '../../actions/dataAPI';
import {
  fetchAllPages,
  setLoadingChart,
  setMarkersColor,
  setNetworksArray,
  setOpenBackendModal,
} from '../../actions/site';
import { setCurrentDate } from '../../actions/metadata';
import { setLoadingFiles } from '../../actions/file';
import { fetchHeader, setLoadingHeader } from '../../actions/header';
import { fetchFooter, setLoadingFooter } from '../../actions/footer';
import { setLoadingPersonalized } from '../../actions/personalized';
import { setOpenCookiePopup } from '../../actions/popupCookie';

// ==================Style&IMG===================
import './styles.scss';
import BackendPopup from '../BackendPopup';
import Page404 from '../Page404';
import { globalConfig } from '../../configuration/config';
import Redirect from '../Redirect';
import SafariModal from '../Header/SafariModal';

// ==================Unused components and actions===================
// import HistoryModal from '../Header/HistoryModal';
// import { setAddToHistory } from '../../actions/menuButton';

function App() {
  // ==================HOOK===================
  const dispatch = useDispatch();
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const markersColors = useSelector((state) => state.site.markersColors);
  const dataAvailable = useSelector((state) => state.site.data.dataAvailable);
  const loadingHeader = useSelector((state) => state.header.loadingHeader);
  const loadingFooter = useSelector((state) => state.footer.loadingFooter);
  const cookiePolicy = JSON.parse(localStorage.getItem('cookiePopup'));
  const localStorageOpenBackenModal = JSON.parse(localStorage.getItem('backendPopup'));
  const backendPopupData = useSelector((state) => state.site.backendPopupData);
  const allPages = useSelector((state) => state.site.allPages);

  // Function allowing you to create the color base of
  // the different markers according to their respective network
  function getMarkersColor() {
    if (dataAPI.length !== 0) {
      dispatch(setMarkersColor([]));
      const firstValue = dataAPI.data[0].network_array[0].split(' & ');
      if (firstValue[0] === 'E-GVAP' || firstValue[0] === 'NFO_TABOO' || firstValue[0] === 'NFO_VRANCEA' || firstValue[0] === 'VOLC' || firstValue[0] === 'EPN' || firstValue[0] === 'IGS') {
        markersColors.push({
          name: [firstValue[0]],
          color: (Math.floor(Math.random() * 0xFFFFFF)).toString(16),
          rotate: parseFloat(Math.random() * 360).toFixed(2),
          invert: parseFloat(Math.random() * 100).toFixed(2),
          borderColor: (Math.floor(Math.random() * 0xFFFFFF)).toString(16),
        });
      }
      else {
        markersColors.push({
          name: [firstValue[0]],
          color: (Math.floor(Math.random() * 0xFFFFFF)).toString(16),
          rotate: parseFloat(Math.random() * 360).toFixed(2),
          invert: parseFloat(Math.random() * 100).toFixed(2),
        });
      }

      dataAPI.data.forEach((station) => {
        const networksplit = station.network.name.split(' & ');
        networksplit.forEach((network) => {
          if (markersColors.find((elem) => JSON.stringify(elem.name) === JSON.stringify(network.split(' & '))) === undefined) {
            let colorNetwork = (Math.floor(Math.random() * 0xFFFFFF)).toString(16);
            if (colorNetwork.length === 5) {
              colorNetwork += 0;
            }
            markersColors.push({
              name: network.split(' & '),
              color: colorNetwork,
              rotate: parseFloat(Math.random() * 360).toFixed(2),
              invert: parseFloat(Math.random() * 100).toFixed(2),

            });
          }
        });
      });
      markersColors.forEach((elem) => {
        if (elem.name[0] === 'E-GVAP' || elem.name[0] === 'NFO_TABOO' || elem.name[0] === 'NFO_VRANCEA' || elem.name[0] === 'VOLC' || elem.name[0] === 'EPN' || elem.name[0] === 'IGS') {
          let borderColorNetwork = (Math.floor(Math.random() * 0xFFFFFF)).toString(16);
          if (borderColorNetwork.length === 5) {
            borderColorNetwork += 0;
          }

          Object.assign(elem, { borderColor: borderColorNetwork });
        }
      });
      dispatch(setMarkersColor(markersColors));
    }
  }

  // function allowing you to create a table of all the networks
  //  with their color names and checkbox value for the drop-down
  // menu on the map allowing you to select the networks to display

  function getNetworksArray() {
    const networksMap = new Map();

    markersColors.forEach((elem) => {
      const networkName = elem.name[0];
      if (!networksMap.has(networkName)) {
        networksMap.set(networkName, {
          ...elem,
          checked: true, // ← on ajoute ici sans muter l'objet original
        });
      }
    });

    const networks = Array.from(networksMap.values());

    // Tri alphabétique
    networks.sort((a, b) => {
      if (a.name[0] < b.name[0]) return -1;
      if (a.name[0] > b.name[0]) return 1;
      return 0;
    });

    dispatch(setNetworksArray(networks));
  }

  // UseMemo to memoize in cache data, fetch station data when application start

  useMemo(
    () => {
      dispatch(fetchStations(globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    },
    [],
  );
  // launch color and network array creation for each change in state of the application
  useEffect(
    () => {
      if (dataAvailable) {
        getMarkersColor();
        getNetworksArray();
      }
    },
  );

  // function allowing you to return the current date according to a certain format
  function currentDateFormat() {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let HH = today.getHours();
    let MM = today.getMinutes();
    let SS = today.getSeconds();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    if (HH < 10) {
      HH = `0${HH}`;
    }
    if (MM < 10) {
      MM = `0${MM}`;
    }
    if (SS < 10) {
      SS = `0${SS}`;
    }
    const todayDate = `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
    return todayDate;
  }

  // launching when starting the application the creation of the current date,
  //  different fetches to fetch information from the backend and indicators
  //  for displaying components and the cookie popup

  useEffect(
    () => {
      dispatch(setCurrentDate(currentDateFormat()));
      // let allHistory = JSON.parse(localStorage.getItem('allHistory'));
      // if (allHistory == null) allHistory = [];
      // localStorage.setItem('allHistory', JSON.stringify(allHistory));
      // dispatch(setAddToHistory(allHistory));
      dispatch(setLoadingChart(true));
      dispatch(setLoadingFiles(true));
      dispatch(fetchAllPages(globalConfig.config.REACT_APP_BACKEND_API));
      dispatch(setLoadingPersonalized(true));
      if (cookiePolicy === null
        || cookiePolicy.value === false
        || cookiePolicy.expire_date < Date.now()) {
        dispatch(setOpenCookiePopup(true));
      }
      else if (cookiePolicy.value === true && cookiePolicy.expire_date > Date.now()) {
        dispatch(setOpenCookiePopup(false));
      }
    },
    [],
  );

  useEffect(() => {
    if (allPages.length > 0) {
      dispatch(setLoadingHeader(true));
      const headerToFetch = allPages.find(
        (el) => el.meta.slug.includes('header'),
      );
      dispatch(fetchHeader(headerToFetch.id, globalConfig.config.REACT_APP_BACKEND_API));
      dispatch(setLoadingFooter(true));
      const footerToFetch = allPages.find(
        (el) => el.meta.slug.includes('footer'),
      );
      dispatch(fetchFooter(footerToFetch.id, globalConfig.config.REACT_APP_BACKEND_API));
    }
  }, [allPages]);

  // save data of information popup in localStorage allows
  //  you to display or not the popup for a particular pose via global API return
  useEffect(() => {
    if (backendPopupData !== undefined) {
      if (backendPopupData.activate) {
        if (localStorageOpenBackenModal === null
          || localStorageOpenBackenModal.value === false
          || localStorageOpenBackenModal.expire_date < Date.now()
          || localStorageOpenBackenModal.creation_date < new Date(backendPopupData.date_updated).getTime()) {
          dispatch(setOpenBackendModal(true));
        }
        if (localStorageOpenBackenModal !== null
          && localStorageOpenBackenModal.value === true
          && localStorageOpenBackenModal.expire_date > Date.now()
          && localStorageOpenBackenModal.creation_date > new Date(backendPopupData.date_updated).getTime()) {
          dispatch(setOpenBackendModal(false));
        }
      }
      if (backendPopupData.activate === false) {
        dispatch(setOpenBackendModal(false));
      }
    }
  }, [backendPopupData]);

  return (
    <div id="app" className="app">
      {(!loadingHeader) && <Header />}
      <main>
        <Routes>
          <Route path="/site" element={<Redirect />} />
          <Route exact path="" element={<Site />} />
          <Route path="/metadata/:slug/:typeInfo" element={<Metadata />} />
          <Route path="/metadata_multiple/*" element={<MultipleMetadata />} />
          <Route path="file/*" element={<File />} />
          <Route path="network/*" element={<Network />} />
          <Route path="epos-gnss-node-infrastructure" element={<NodeInfo />} />
          <Route path="/:slug" element={<Personalized />} />
          <Route path="404" element={<Page404 />} />
          <Route path="*" element={<Navigate to="404" replace />} />
        </Routes>
      </main>
      <div><ModalCommandLineClient /></div>
      <div><SafariModal /></div>
      {/* <div><HistoryModal /></div> */}
      {(!loadingHeader && !loadingFooter) && <div><PopupCookie /></div>}
      {(!loadingHeader && !loadingFooter) && <div><BackendPopup /></div>}
      {(!loadingFooter) && <Footer />}
    </div>
  );
}

// == Export
export default App;
